/**
 * The options for the Charts
 */
export const Configs = {
    config_donut: {
        "title": "",
        "resizable": true,
        "donut": {
            "center": {
                "label": "Reservierungen"
            },
            "alignment": "center"
        },
        "toolbar": {
            "enabled": false,
        },
        "tooltip": {
            "truncation": {
                "threshold": 124
            }
        },
        "legend": {
            "alignment": "center",
            "truncation": {
                "threshold": 124
            }
        },
        "height": "300px"
    },

    config_donut_types: {
        "title": "",
        "resizable": true,
        "donut": {
            "center": {
                "label": "Aktionen"
            },
            "alignment": "center"
        },
        "toolbar": {
            "enabled": false
        },
        "tooltip": {
            "truncation": {
                "threshold": 124
            }
        },
        "legend": {
            "alignment": "center",
            "truncation": {
                "threshold": 124
            }
        },
        "height": "300px"
    },


    options_line: {
        "title": "",
        "axes": {
            "bottom": {
                "title": "Datum",
                "mapsTo": "date",
                "scaleType": "time",
                "ticks": {
                    "formatter": d => d.toLocaleDateString("de-De", {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                    })
                }
            },
            "left": {
                "mapsTo": "value",
                "title": "Anzahl",
                "scaleType": "linear"
            }
        },
        "legend": {
            "alignment": "center"
        },
        "zoomBar": {
            "updateRangeAxis": true,
            "zoomRatio": 1.0,
            "top": {
                "enabled": false,
            },
        },
        "toolbar": {
            "enabled": false,
        },
        "tooltip": {
            "truncation": {
                "threshold": 124
            },
            "groupLabel": "Gruppe",


            "valueFormatter": d => d.toLocaleString()
        },
        "curve": "curveMonotoneX",
        "height": "400px"
    },




    data_radar: [

    ],
    options_radar: {
        "title": "",
        "axes": {
            "left": {
                "mapsTo": "value",
                "title": "Anzahl",
            },
            "bottom": {
                "scaleType": "labels",
                "mapsTo": "key",
                "title": "Art",
            }
        },
        "toolbar": {
            "enabled": false,
        },
        "legend": {
            "alignment": "center",
            "truncation": {
                "threshold": 124
            }
        },
        "tooltip": {
            "groupLabel": "Aktion",
            "showTotal": false,
            "truncation": {
                "threshold": 124
            }
        },
        "resizable": true,
        "height": "400px"
    },

    options_line_simple: {
        "title": "",
        "axes": {
            "left": {
                "mapsTo": "value",
                "title": "Anzahl"
            },
            "bottom": {
                "mapsTo": "group",
                "scaleType": "labels",
                "title": "Kategorie",
            }
        },
        "tooltip": {
            "groupLabel": "Kategorie",
            "truncation": {
                "threshold": 124
            }
        },
        "toolbar": {
            "enabled": false,
        },
        "legend": {
            "alignment": "center"
        },
        "resizable": true,
        "height": "400px"
    },

    options_line_partners: {
        "title": "",
        "binned": "true",
        "axes": {
            "left": {
                "mapsTo": "value",
                "title": "Anzahl",

            },
            "bottom": {
                "mapsTo": "group",
                "scaleType": "labels",
                "title": "Partner",
                "truncation": {
                    "threshold": 30
                }
            }
        },
        "tooltip": {
            "groupLabel": "",
            "showTotal": false,
            "truncation": {
                "threshold": 60
            }
        },
        "toolbar": {
            "enabled": false,
        },
        "legend": {
            "alignment": "center",
            "truncation": {
                "threshold": 50
            }
        },
        "resizable": true,
        "height": "400px"
    },


    options_line_savings: {
        "title": "",
        "axes": {
            "left": {
                "mapsTo": "value",
                "title": "Anzahl"
            },
            "bottom": {
                "mapsTo": "group",
                "scaleType": "labels",
                "title": "Preisnachlass in %",
                "truncation": {
                    "threshold": 124
                }
            }
        },
        "tooltip": {
            "groupLabel": "",
            "truncation": {
                "threshold": 124
            }
        },
        "toolbar": {
            "enabled": false,
        },
        "legend": {
            "alignment": "center",
            "truncation": {
                "threshold": 124
            }
        },
        "resizable": true,
        "height": "400px"
    },

    tree_options: {
        "title": "",
        "height": "1000px",
        "tree": {
            "type": "dendrogram",
            "rootTitle": "Aktionen"
        },
        "tooltip": {
            "groupLabel": "Preisnachlass in %",
            "truncation": {
                "threshold": 124
            }
        },
        "toolbar": {
            "enabled": false,
        },
        "legend": {
            "alignment": "center"
        }
    },

    treemap_options: {
        "title": "",
        "height": "600px",
        "toolbar": {
            "enabled": false,
        },
        "legend": {

            "alignment": "center"
        }
    },

    config_donut_users: {
        "title": "",
        "resizable": true,
        "donut": {
            "center": {
                "label": "Nutzer"
            },
            "alignment": "center"
        },
        "toolbar": {
            "enabled": false,
        },
        "tooltip": {
            "truncation": {
                "threshold": 124
            }
        },
        "legend": {
            "alignment": "center",
            "truncation": {
                "threshold": 124
            }
        },
        "height": "300px"
    },

    options_line_year: {
        "title": "",
        "axes": {
            "left": {
                "mapsTo": "value",
                "title": "Anzahl Kunden"
            },
            "bottom": {
                "mapsTo": "group",
                "scaleType": "labels",
                "title": "Jahr",
            }
        },
        "tooltip": {
            "groupLabel": "Jahr",
            "truncation": {
                "threshold": 124
            }
        },
        "toolbar": {
            "enabled": false,
        },
        "legend": {
            "alignment": "center"
        },
        "resizable": true,
        "height": "400px"
    },

    options_word_cloud: {
        "title": "",
        "resizable": true,
        "tooltip": {
            "groupLabel": "",
            "valueLabel": "Anzahl",
            "wordLabel": "Wort",
            "truncation": {
                "threshold": 40
            }
        },

        "toolbar": {
            "enabled": false,
        },
        "legend": {
            "alignment": "center"
        },
        "height": "400px"
    },
    options_line_reservations: {
        "title": "",
        "axes": {
            "bottom": {
                "title": "Datum",
                "mapsTo": "key",
                "scaleType": "labels"
            },
            "left": {
                "mapsTo": "value",
                "title": "Reservierungen",
                "scaleType": "linear"
            }
        },
        "tooltip": {
            "showTotal" : false,
            "groupLabel": "",
            "truncation": {
                "threshold": 124
            }
        },
        "toolbar": {
            "enabled": false,
        },
        "legend": {
            "alignment": "center"
        },
        "resizable": true,
        "height": "400px"
    },

    options_line_agegroup: {
        "title": "",
        "axes": {
            "left": {
                "mapsTo": "value",
                "title": "Anzahl Kunden"
            },
            "bottom": {
                "mapsTo": "group",
                "scaleType": "labels",
                "title": "Gruppe",
            }
        },
        "tooltip": {
            "groupLabel": "Gruppe",
            "truncation": {
                "threshold": 124
            }
        },
        "toolbar": {
            "enabled": false,
        },
        "legend": {
            "alignment": "center"
        },
        "resizable": true,
        "height": "400px"
    },
    avg_reservation : {
        "title": "Horizontal box plot",
		"axes": {
				"bottom": {
						"mapsTo": "value"
				},
				"left": {
						"scaleType": "labels",
						"mapsTo": "group"
				}
		},
		"height": "400px"
    },
    circle_pack_options : {
        "title": "",
        "axes": {
            "left": {
                "mapsTo": "value",
                "title": "Anzahl Kunden"
            },
            "bottom": {
                "mapsTo": "group",
                "scaleType": "labels",
                "title": "Gruppe",
            }
        },
        "tooltip": {
            "groupLabel": "Gruppe",
            "truncation": {
                "threshold": 124
            }
        },
        "toolbar": {
            "enabled": false,
        },
        "legend": {
            "enabled": false,
            "alignment": "center"
        },
        "resizable": true,
        "height": "400px"
    },
    options_bar_horizontal : {
        "title": "",
        "axes": {
          "left": {
            "mapsTo": "group",
            "scaleType": "labels",
            "title": "Aktion"
          },
          "bottom": {
            "mapsTo": "value",
            "title": "Anzahl Reservierungen",

          }
        },
        "tooltip": {
            "groupLabel": "Aktion",
            "truncation": {
                "threshold": 124
            }
        },
        "toolbar": {
            "enabled": false,
        },
        "legend": {
            "enabled": false,
            "alignment": "center"
        },
        "resizable": true,
        "height": "400px",
      }
}
